/**
 * Interface for Schedulers
 */
export default class Scheduler {
	clearSchedule(): this | void {
		throw new Error('Not implemented');
	}
	clearScheduler(): this | void {
		throw new Error('Not implemented');
	}
}
